import { color } from '../../styles/GlobalStyles';
import { Flexed, UserImageCircle } from '../../styles/GlobalComponents';
import { InviteLinks, ReferralLink } from './DashboardStyled';
import { P2, P3 } from '../../styles/FontStyles';
import { User } from '../../types/loginTypes';
import { copyLink } from '../../helpers/helperFunctions';

import facebookIcon from '../../assets/icons/facebook.png';
import instagramIcon from '../../assets/icons/instagram.png';
import xIcon from '../../assets/icons/x.png';

export const ProfileInfo = ({ user }: { user: User }) => {
  return (
    <InviteLinks>
      <UserImageCircle
        image={user?.profileImageUrl}
        name={user?.name}
        surname={user?.surname}
        size='60px'
        fontSize='20px'
        color={color.colors.neutral0}
        fontColor={color.colors.primary900}
      />
      <div>
        <P2 bold color={color.colors.neutral0}>
          {user?.name}
        </P2>
        <P3 color={color.colors.neutral0}>ID: {user?.id}</P3>
      </div>
    </InviteLinks>
  );
};

export const ReplicatedLinks = ({ referralUrl }: { referralUrl: string }) => {
  return (
    <>
      <>
        <Flexed
          pointer
          mt='20'
          mtSM='20'
          mb='10'
          gap='10px'
          onClick={() => {
            copyLink(referralUrl, 'Replicated link has been copied');
          }}>
          <P2 semiBold>Replicated Website Link</P2>
          <svg
            width='19'
            height='19'
            viewBox='0 0 19 19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M11.875 0.990235H8.66367C7.20878 0.990222 6.0564 0.990212 5.15452 1.11147C4.22636 1.23626 3.47511 1.49918 2.88265 2.09164C2.2902 2.68409 2.02727 3.43534 1.90248 4.36351C1.78123 5.26538 1.78124 6.41776 1.78125 7.87265V12.6673C1.78125 14.1495 2.86746 15.378 4.28728 15.6002C4.39651 16.2051 4.60554 16.7213 5.02578 17.1415C5.5023 17.6181 6.10228 17.823 6.81486 17.9188C7.50121 18.0111 8.37388 18.0111 9.45656 18.0111H11.9184C13.0011 18.0111 13.8738 18.0111 14.5601 17.9188C15.2727 17.823 15.8727 17.6181 16.3492 17.1415C16.8257 16.665 17.0307 16.065 17.1265 15.3525C17.2188 14.6661 17.2188 13.7934 17.2188 12.7108V8.66555C17.2188 7.58287 17.2188 6.7102 17.1265 6.02385C17.0307 5.31126 16.8257 4.71128 16.3492 4.23476C15.929 3.81453 15.4127 3.60549 14.8079 3.49627C14.5857 2.07644 13.3572 0.990235 11.875 0.990235ZM13.5607 3.38199C13.321 2.68142 12.6568 2.17774 11.875 2.17774H8.70833C7.19877 2.17774 6.12632 2.179 5.31276 2.28838C4.51627 2.39546 4.05738 2.59628 3.72234 2.93132C3.3873 3.26637 3.18648 3.72525 3.07939 4.52174C2.97001 5.33531 2.96875 6.40775 2.96875 7.91732V12.6673C2.96875 13.4491 3.47244 14.1133 4.17301 14.353C4.15623 13.8702 4.15624 13.3242 4.15625 12.7108V8.66554C4.15623 7.58287 4.15622 6.7102 4.2485 6.02385C4.3443 5.31126 4.54926 4.71128 5.02578 4.23476C5.5023 3.75824 6.10228 3.55329 6.81486 3.45748C7.50121 3.36521 8.37388 3.36522 9.45656 3.36523H11.9184C12.5318 3.36523 13.0778 3.36522 13.5607 3.38199ZM5.86547 5.07445C6.08457 4.85535 6.39219 4.71249 6.9731 4.63439C7.57108 4.554 8.36363 4.55274 9.5 4.55274H11.875C13.0114 4.55274 13.8039 4.554 14.4019 4.63439C14.9828 4.71249 15.2904 4.85535 15.5095 5.07445C15.7286 5.29356 15.8715 5.60117 15.9496 6.18208C16.03 6.78007 16.0312 7.57261 16.0312 8.70898V12.6673C16.0312 13.8037 16.03 14.5962 15.9496 15.1942C15.8715 15.7751 15.7286 16.0827 15.5095 16.3019C15.2904 16.521 14.9828 16.6638 14.4019 16.7419C13.8039 16.8223 13.0114 16.8236 11.875 16.8236H9.5C8.36363 16.8236 7.57108 16.8223 6.9731 16.7419C6.39219 16.6638 6.08457 16.521 5.86547 16.3019C5.64636 16.0827 5.50351 15.7751 5.42541 15.1942C5.34501 14.5962 5.34375 13.8037 5.34375 12.6673V8.70898C5.34375 7.57261 5.34501 6.78007 5.42541 6.18208C5.50351 5.60117 5.64636 5.29356 5.86547 5.07445Z'
              fill='#373737'
            />
          </svg>
        </Flexed>

        <ReferralLink>{referralUrl}</ReferralLink>
      </>

      <Flexed mt='20' mtSM='20' mb='10' gap='20px'>
        <P2 semiBold>Social Media</P2>
      </Flexed>
      <Flexed gap='10px' mb='30' justifyCenter>
        <a
          href='https://www.facebook.com/UnitedOne.Global'
          target='_blank'
          rel='noreferrer'>
          <img src={facebookIcon} alt='facebook' width='30' height='30' />
        </a>
        <a
          href='https://www.instagram.com/unitedone.global'
          target='_blank'
          rel='noreferrer'>
          <img src={instagramIcon} alt='instagram' width='30' height='30' />
        </a>
        <a href='https://x.com/united1global' target='_blank' rel='noreferrer'>
          <img src={xIcon} alt='x' width='30' height='30' />
        </a>
      </Flexed>
    </>
  );
};
